import { useMemo } from 'react'
import { DeliveryNotesFileOptions } from './deliveryNotesFileOptions'
import { DownloadFilesModal, FileOption } from '../../../../../features/files'
import { Delivery, DeliveryOrder } from '../../../state/types'

type Props = {
    deliveries: Delivery[]
    deliveryOrders: DeliveryOrder[]
}

export const DownloadDeliveryNotesModal = (props: Props) => {
    const { deliveries, deliveryOrders } = props

    const deliveryNotesFileOptions = DeliveryNotesFileOptions({ deliveries, deliveryOrders })

    const fileOptions = useMemo(() => {
        const options: FileOption[] = []

        if (deliveryNotesFileOptions.length > 0) {
            options.push(...deliveryNotesFileOptions)
        }

        return options
    }, [deliveryNotesFileOptions])
    
    return <DownloadFilesModal fileOptions={fileOptions} grouped={false} />
}
